//导航栏入口

import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return isMobile ? <MobileNavbar /> : <DesktopNavbar />;
};

export default Navbar;
